// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NLPw","colMin":"styles_colMin__OtEAL"};